import { Divider, Menu, MenuItem } from '@material-ui/core';
import React, { MouseEventHandler, useState } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';

import cdsConfig from '../styles/cds.config';
import { RiArrowDownSLine } from 'react-icons/ri';

const StyledNavMenu = styled.div<{active: boolean}>`
  position: relative;
  display: flex;
  font-size: ${cdsConfig.fontSizes[100]};
  line-height: 1;
  align-items: center;
  justify-content: center;
  color: ${props => props.active ? cdsConfig.colors['ct-green-500'] : cdsConfig.colors['text-nav-normal']};
  border-bottom: 3px solid transparent;
  border-color: ${props => props.active ? cdsConfig.colors['ct-green-500'] : 'transparent'};
  cursor: pointer;
  padding: ${cdsConfig.space.$04} ${cdsConfig.space.$06};
`;

const NewsLetterMenuText = styled.span`
  font-size: ${cdsConfig.fontSizes[100]};
  padding-right: ${cdsConfig.space.$01};
`;

const StyledMenuIconBox = styled.span<{ open: boolean }>`
  transform: ${props => props.open ? 'rotate(180deg)' : 'rotate(0deg)'};
  font-size: ${cdsConfig.fontSizes['size-100']};
  height: 1rem;
`;

const S = {
  Menu: styled(Menu)`
  .MuiList-padding {
    padding: 0;
  }
`,
  MenuItem: styled(MenuItem)`
    width: 7.875rem;
    height: 3.5rem;
    color: ${cdsConfig.colors['text-dark']};
    font-size: ${cdsConfig.fontSizes['size-100']};
    padding: ${cdsConfig.space.$04};
    display: flex;
    flex: 1 1 0;
    overflow: hidden;
    align-items: center;

    :hover {
      background-color: ${cdsConfig.colors['gray-100']};
    }
  `,
  Divider: styled(Divider)`
    border-top: 1px solid ${cdsConfig.colors['gray-200']}
  `,
};

const NewsLetterNavLink = () => {
  const { sid } = useParams<{sid: string}>();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const handleClick: MouseEventHandler<HTMLDivElement> = ((event) => setAnchorEl(event?.currentTarget ?? null));
  const handleClose = () => setAnchorEl(null);
  const active = location.pathname.includes(`/schools/${sid}/school-newsletters`) || location.pathname.includes(`/schools/${sid}/contacts`);

  return (
    <>
      <StyledNavMenu
        active={active}
        onClick={handleClick}
        aria-controls="newsletter-menu"
        aria-haspopup="true"
      >
        <NewsLetterMenuText>가정통신문</NewsLetterMenuText>
        <StyledMenuIconBox open={!!anchorEl}>
          <RiArrowDownSLine />
        </StyledMenuIconBox>
      </StyledNavMenu>
      <S.Menu
        id="newsletter-menu"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={!!anchorEl}
        onClose={handleClose}
      >
        <NavLink
          to={{
            pathname: `/schools/${sid}/school-newsletters`,
            state: { from: location.pathname },
          }}
          onClick={handleClose}
        >
          <S.MenuItem>
            가정통신문
          </S.MenuItem>
        </NavLink>
        <S.Divider />
        <NavLink
          to={{
            pathname: `/schools/${sid}/contacts`,
            state: { from: location.pathname },
          }}
          onClick={handleClose}
        >
          <S.MenuItem>
            주소록
          </S.MenuItem>
        </NavLink>
      </S.Menu>
    </>
  );
};

export default NewsLetterNavLink;
